


import { MenuItems } from './menu-items/menu-items';
import { AccordionAnchorDirective, AccordionLinkDirective, AccordionDirective } from './accordion';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule, MatDatepickerModule, MatInputModule, MatOptionModule, MatSelectModule, MatRadioModule, MatTableModule, MatButtonModule, MatIconModule, MatToolbarModule, MatSidenavModule, MatListModule, MatMenuModule, MatExpansionModule, MatTooltipModule, MatProgressBarModule } from '@angular/material';
import { MatTabsModule } from "@angular/material/tabs";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { MatNativeDateModule } from "@angular/material/core";
import { SpinnerComponent } from './spinner/spinner.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { SearchBtnComponent } from './search-btn/search-btn.component';
import { ResetBtnComponent } from './reset-btn/reset-btn.component';
import { AddBtnComponent } from './add-btn/add-btn.component';
import { AlertComponent } from './alert/alert.component';
import { AlertModule, AlertConfig } from 'ngx-bootstrap/alert';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ImageCropperModule } from 'ngx-image-cropper';
import { CommonModule } from '@angular/common';
import { NoFile } from './no-file/no-file';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { NgbAlertModule, NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
import {MatChipsModule} from '@angular/material/chips';
import { NgSelectModule } from "@ng-select/ng-select";
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CKEditorModule } from 'ckeditor4-angular';
import { LinkifyPipe } from './linkify.pipe';
// import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import {DragDropModule} from '@angular/cdk/drag-drop';

import {MatCheckboxModule} from '@angular/material/checkbox';
import { FilterPipe } from './filter.pipe';
import { KeysPipe } from '../main/forms-table-data/keys.pipe';
@NgModule({
  declarations: [
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    SpinnerComponent,
    SearchBtnComponent,
    ResetBtnComponent,
    AddBtnComponent,
    AlertComponent,
   NoFile,
   LinkifyPipe,
   FilterPipe,
   KeysPipe
  ],
  imports:[CommonModule, InfiniteScrollModule,DragDropModule,MatProgressBarModule,  MatSnackBarModule,FormsModule,MatExpansionModule,AlertModule.forRoot(),NgMultiSelectDropDownModule.forRoot()],
  
  exports: [
    FormsModule, ReactiveFormsModule,
    AccordionAnchorDirective,
    AccordionLinkDirective,
    AccordionDirective,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatOptionModule,
    MatIconModule,
    MatSelectModule,
    MatTabsModule,
    MatToolbarModule,
    MatSidenavModule,
    MatRadioModule,
    MatMenuModule,
    MatSnackBarModule,
    MatTableModule,MatButtonModule,MatListModule,
    NgxDatatableModule,
    SpinnerComponent,
    SearchBtnComponent,
    ResetBtnComponent,
    AlertComponent,
    AlertModule,
    NgMultiSelectDropDownModule,
    ImageCropperModule,
    CommonModule,
    NoFile,MatProgressSpinnerModule,
    NgbAlertModule,
    NgbPaginationModule,
    MatSlideToggleModule,
    MatExpansionModule,
    MatChipsModule,
    NgSelectModule,
    NgxMaterialTimepickerModule,
    CKEditorModule,
    InfiniteScrollModule,
    MatProgressBarModule,
    DragDropModule,
    MatCheckboxModule,
    FilterPipe,
    KeysPipe

   ],
  providers: [ MenuItems,AlertConfig ],

})
export class SharedModule { }
